import React from 'react';

export const MenuItemGroupContext = React.createContext({
  menuOpen: false,
  setMenuOpen: () => null
});

export const MenuItemGroupProvider = MenuItemGroupContext.Provider;
export const MenuItemGroupConsumer = MenuItemGroupContext.Consumer;
export default MenuItemGroupContext;
